import {
  resourceState,
  resourceMutations,
  resourceGetters,
  resourceActions,
} from '@/store/utils/resource';
import { USERS } from '@/store/entities/schema_types';
import { contactRequestUserClient as client } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  getters: resourceGetters(USERS),
  actions: {
    ...resourceActions,
    async read(ctx, { id, query = {} }) {
      try {
        const response = await client.read(id, query);

        let userId = null;

        if (response.data) {
          userId = await ctx.dispatch(
            'entities/persistEntities',
            { type: USERS, data: response.data },
            { root: true }
          );
        }

        ctx.commit({
          type: 'setIdByParent',
          parentId: id,
          id: userId,
        });

        return Promise.resolve({ userId });
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
    async update(ctx, { id, formData }) {
      try {
        await client.update(id, mapKeysToSnakeCase(formData));

        ctx.commit({
          type: 'setIdByParent',
          parentId: id,
          id: formData.userId,
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
